<template>
    <div class="main-container">
        <div class="main-container-title-box">
            <div class="main-container-title-box-text">
                <span class="title-box-text">
                    Список новостей
                </span>
                <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false"
                    color="var(--app-dark-blue-1)">mdi-information</v-icon>
            </div>
            <v-btn @click="goToCreate" class=" button-accept">
                + Создать новость
            </v-btn>
            <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
                <v-card min-width="300px" min-height="100px">
                    <div class="menu-container">
                        <div class="menu-container-title">
                            «Список новостей»
                        </div>
                        <div class="menu-container-text">
                            Основной список отображающийся во вкладке меню мобильного приложения "Новости"
                        </div>
                        <div class="menu-container-title">
                            Иконка
                            <v-icon small color="#929292">
                                mdi-eye-off
                            </v-icon>
                        </div>
                        <div class="menu-container-text">
                            Если эта иконка показывается – значит эта новость скрыта
                        </div>
                        <div class="menu-container-title">
                            Иконка
                            <v-icon small color="#929292">
                                mdi-star
                            </v-icon>
                        </div>
                        <div class="menu-container-text">
                            Вместо порядкового номера - звездочка - значит это главная новость. Главная новость отображается
                            всегда первой в списке с большим изображением.
                        </div>
                        <div class="menu-container-title">
                            Иконка
                            <v-icon small color="#929292">
                                mdi-bell
                            </v-icon>
                        </div>
                        <div class="menu-container-text">
                            При отображении колокольчика около даты - отправится/отправлялось push-уведомление при
                            публикации новости
                        </div>
                    </div>

                </v-card>
            </v-menu>

        </div>

        <v-tabs class="container-banners-tabs" color="var(--app-dark-blue-1)" v-model="tabs" @change="tabsChange()">
            <v-tab>
                В разделе "Новости"
            </v-tab>
            <v-tab>
                Скрытые новости
            </v-tab>
            <v-tab-item>
                <div class="table-container" v-if="!loading">
                    <v-data-table :footer-props="{ itemsPerPageOptions: [10, 25, 50], 'items-per-page-text': '' }"
                        :headers="tableHeaders" :items="news" class="elevation-0 main-table"
                        :items-per-page="optionTable.itemsPerPage" :page="optionTable.page" hide-default-header
                        :server-items-length="optionTable.serverItemsLength" @pagination="tableChange" ref="sortableTable"
                        fixed-header>
                        <template v-slot:header>
                            <thead>
                                <tr>
                                    <th v-for="(s, index ) in tableHeaders" :key="index">
                                        <div style="margin-left: 24px"
                                            v-if="s.text == 'Заголовок' || s.text == 'Дата публикации'">
                                            {{ s.text }}
                                        </div>
                                        <div style="max-width: 100px !important;"
                                            v-else-if="s.text == 'Порядок отображения'">
                                            {{ s.text }}
                                        </div>
                                        <div v-else>
                                            {{ s.text }}
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                        </template>
                        <template slot="body">
                            <draggable :list="news" tag="tbody" @end="endDrag" :move="checkMove"
                                :style="moveItems ? 'pointer-events: none;' : ''">
                                <tr v-for="(item, index) in news" :key="index" @click="goToDetail(item)"
                                    style="  height: auto;">
                                    <td>
                                        <v-icon small style="cursor: pointer" :disabled="moveItems ? true : false">
                                            mdi-menu
                                        </v-icon>
                                    </td>

                                    <td v-if="item.toHead">
                                        <v-icon small>
                                            mdi-star
                                        </v-icon>

                                    </td>
                                    <td v-else>

                                        {{ item.newsIndex }}
                                    </td>

                                    <td v-if="!item.toShowOnMainScreen && !item.toShowInNews">
                                        <div class="d-flex align-center">
                                            <v-icon small>
                                                mdi-eye-off
                                            </v-icon>
                                            <div style="margin-left: 8px"> {{ item.name }}</div>
                                        </div>
                                    </td>
                                    <td v-else>
                                        <div class="d-flex align-center">
                                            <div style="width: 24px"></div>
                                            <div> {{ item.name }}</div>
                                        </div>
                                    </td>

                                    <td>
                                        <div style="margin: 8px 0" v-for="i in item.categories.slice(0, 3)" :key="i.id">
                                            {{ i.name }}
                                        </div>


                                    </td>
                                    <td v-if="item.mustSendPush">
                                        <div class="d-flex align-center">
                                            <v-icon small style="margin-right: 8px">
                                                mdi-bell
                                            </v-icon>
                                            {{ item.datePublished | moment("DD.MM.YYYY HH:mm") }}
                                        </div>
                                    </td>
                                    <td v-else>
                                        <div class="d-flex align-center">
                                            <div style="width: 24px"></div>
                                            {{ item.datePublished | moment("DD.MM.YYYY HH:mm") }}
                                        </div>
                                    </td>
                                </tr>
                            </draggable>

                        </template>
                    </v-data-table>


                </div>
            </v-tab-item>
            <v-tab-item>
                <div class="table-container" v-if="!loading">
                    <v-data-table :footer-props="{ itemsPerPageOptions: [10, 25, 50], 'items-per-page-text': '' }"
                        :headers="tableHeadersHidden" :items="news" class="elevation-0 main-table"
                        :items-per-page="optionTable.itemsPerPage" :page="optionTable.page"
                        :server-items-length="optionTable.serverItemsLength" @pagination="tableChange" ref="sortableTable"
                        fixed-header @click:row="goToDetail">
                        <template v-slot:item.categories="{ item }">
                            <div style="margin: 8px 0" v-for="i in item.categories.slice(0, 3)" :key="i.id">
                                {{ i.name }}
                            </div>
                        </template>
                        <template v-slot:item.date="{ item }">
                            {{ item.datePublished | moment("DD.MM.YYYY HH:mm") }}
                        </template>
                    </v-data-table>


                </div>
            </v-tab-item>
        </v-tabs>

        <v-divider></v-divider>
    </div>
</template>
<script>

import draggable from "vuedraggable";
export default {
    components: {
        draggable
    },
    data: () => ({
        showInfo: false,
        x: null,
        y: null,
        news: [],
        sortedNumbers: [],
        moveItems: false,
        selectedDrag: '',
        optionTable: {
            page: 1,
            itemsPerPage: 10,
            serverItemsLength: -1
        },
        tabs: 0,
        tableHeaders: [
            {
                text: '',
                sortable: false
            },
            {
                text: 'Порядок отображения',
                value: '',
                sortable: false
            },
            {
                text: 'Заголовок',
                sortable: false,
                value: 'name',

            },
            {
                text: 'Категории',
                sortable: false,
                value: 'categories',
            },
            {
                text: 'Дата публикации',
                sortable: false,
                value: 'date',
            },

        ],
        tableHeadersHidden: [
            {
                text: 'Заголовок',
                sortable: false,
                value: 'name',

            },
            {
                text: 'Категории',
                sortable: false,
                value: 'categories',
            },
            {
                text: 'Дата публикации',
                sortable: false,
                value: 'date',
            },

        ],
        isOnMainScreen: false,
        isInNews: false,
        loading: true
    }),
    methods: {
        checkLocal() {
            const localOptionTable = JSON.parse(localStorage.getItem("newsOptionTable"))
            if (localOptionTable) {
                this.optionTable = localOptionTable
            }

        },
        tabsChange() {
            this.loading = true
            this.news = []
            this.optionTable = {
                page: 1,
                itemsPerPage: 10,
                serverItemsLength: -1
            }
            this.getNews()
        },
        openInfo(e) {

            e.preventDefault()

            this.x = e.clientX + 10
            this.y = e.clientY + 10
            this.showInfo = true
        },
        goToCreate() {
            this.$router.push({ name: 'NewsCreate' })

        },
        goToDetail(item) {
            this.$router.push({ name: 'NewsDetail', params: { id: item.id } })

        },
        getNews() {
            this.isOnMainScreen = false
            this.isInNews = this.tabs == 0 ? true : false

            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/news/list', {
                optionTable: this.optionTable,
                isOnMainScreen: this.isOnMainScreen,
                isInNews: this.isInNews
            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(res => {
                    this.optionTable = res.data.optionTable;
                    this.news = res.data.items
                    this.loading = false
                    // const numberOnly = this.news.map(item=>{
                    //     return item.index
                    // })
                    // this.sortedNumbers = numberOnly.sort((a,b) =>{
                    //     return a - b;
                    // })

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        tableChange(data) {

            this.optionTable.page = data.page
            this.optionTable.itemsPerPage = data.itemsPerPage
            localStorage.setItem('newsOptionTable', JSON.stringify(this.optionTable))
            this.getNews()
        },

        endDrag(evt) {
            this.moveItems = true
            this.$axios.put(this.$store.getters.apiAdminPanelV2 + '/news/sort', {
                newsId: this.selectedDrag,
                index: (this.optionTable.itemsPerPage * (this.optionTable.page - 1)) + evt.newIndex + 1,
                isOnMainScreen: this.isOnMainScreen,
                isInNews: this.isInNews

            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(() => {
                    this.getNews()
                    this.moveItems = false


                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                    this.moveItems = false
                })

        },
        checkMove(evt) {
            this.selectedDrag = evt.draggedContext.element.id
        },
    },
    watch: {
    },
    created() {
        this.checkLocal()
        this.getNews()
    },
}
</script>
<style lang="scss" scoped>
.table-container {
    height: calc(100vh - 238px);

    .main-table {
        height: calc(100vh - 238px) !important;
        min-height: calc(100vh - 238px) !important;
        max-height: calc(100vh - 238px) !important;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

    }
}
</style>